import React from 'react';
import { Image } from 'react-native';
import { WindowInformation } from '../../../services/window-information';
import DragAndZoom from '../../../components/DragAndZoom';
import BasicModal from '../../../components/BasicModal';
import { translate } from '../../../services/translate';

interface Props {
    imageUrl: string;
    isModalVisible: boolean;
    setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function ImageModal({ imageUrl, isModalVisible, setIsModalVisible }: Props) {
    const windowInfo = WindowInformation();

    return <BasicModal
        isModalVisible={isModalVisible}
        setModalVisible={setIsModalVisible}
        title={translate('attachment')}
        width='extra-large'
        cancelButton={{
            customText: translate('close'),
        }}
    >
        <DragAndZoom>
            <Image source={{ uri: imageUrl }} style={{
                width: windowInfo.width - (24 * 2),
                height: windowInfo.height - 200,
                resizeMode: 'contain',
            }} />
        </DragAndZoom>
    </BasicModal>;
}
